import { render, staticRenderFns } from "./favourite_row.vue?vue&type=template&id=532b1fc1&"
import script from "./favourite_row.vue?vue&type=script&lang=js&"
export * from "./favourite_row.vue?vue&type=script&lang=js&"
import style0 from "./favourite_row.vue?vue&type=style&index=0&id=532b1fc1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports